import { Module } from '@nestjs/common';
import { CodeListController } from './code-list.controller';
import { CodeListService } from './code-list.service';
import {CodeList} from './code-list.entity'
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { CodeListAdapter} from './dto/code-list.adapter'
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    
    TypeOrmModule.forFeature([CodeList]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [CodeListController],
  providers: [CodeListService,ApplicationExceptionHandler,CodeListAdapter,LogsService]
})
export class CodeListModule {}
